import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Box, Text, Heading, Button, Link } from '@chakra-ui/react';
import Layout from '../../components/Layout';
import HeroWithBackgroundImage from '../../components/shared/HeroWithBackgroundImage';
import InfoSection from '../../components/shared/InfoSection';
import TryHoverTodaySection from '../../components/shared/TryHoverTodaySection';
import TwoColumns from '../../components/shared/TwoColumns';
import VideoPlayer from '../../components/shared/VideoPlayer';
import FeaturedPosts from '../../components/shared/FeaturedPosts';
import FAQSection from './FAQSection';
import HeroImage from '../../images/Connect-Page-Header.webp';

const INFO_ITEMS = [
  {
    image: <StaticImage src="../../images/iphone-icon.svg" alt="Icon iPhone" />,
    title: 'Get measurements',
    description:
      'The homeowner takes a few photos and you get accurate measurements before your meeting',
  },
  {
    image: (
      <Box minH="91px">
        <StaticImage src="../../images/design-icon.svg" alt="Icon design" />
      </Box>
    ),
    title: 'Design together',
    description:
      'Choose colors and pick materials with the homeowner in an interactive 3D model',
  },
  {
    image: (
      <Box minH="91px">
        <StaticImage
          src="../../images/virtual-meeting-icon.svg"
          alt="Icon virtual meeting"
        />
      </Box>
    ),

    title: 'Quote and close',
    description:
      'Everything you need to build the rapport, trust, and credibility to close on the first call',
  },
];

const FEATURED_POSTS = {
  mainPost: {
    image: (
      <StaticImage
        src="../../images/MD-627_RemoteEngagement_Image2_Header-Clean-1.webp"
        alt="remote engagement"
      />
    ),
    title: 'The Power of Two Call Closing in One Virtual Meeting',
    slug: 'no-call-close',
    description:
      'It is increasingly common for homeowners to reject the in-person appointment in favor of a virtual one. The right virtual meeting can remove unnecessary site-visits that slow down the process while still allowing you to flex your customer service muscle...',
  },
  secondaryPosts: [
    {
      image: (
        <StaticImage
          src="../../images/MD-416-Blog-Header-Image_WebinarSeries2.webp"
          alt="webinar"
        />
      ),
      title: 'How to Enable Virtual Selling',
      slug: 'virtual-selling-for-your-home-improvement-business',
    },
    {
      image: (
        <StaticImage src="../../images/blog-image-plan.webp" alt="blog photo" />
      ),
      title: 'Best Practices to Help Restoration Contractors Thrive Remotely',
      slug: 'best-practices-for-restoration-contractors-during-covid-19',
    },
  ],
};

const RemoteEngagementForContractors = () => (
  <Layout
    title="Remote Engagement | Home Improvement"
    description="Transition your business and implement a virtual, no-touch sales process. Keep your home improvement projects moving forward."
  >
    <HeroWithBackgroundImage
      backgroundColor="'rgba(255,255,255,.55)'"
      imageUrl={HeroImage}
      title="The No Call Close"
      description="Get the benefits of a two call close with one virtual meeting"
    />
    <TwoColumns
      minH="800px"
      col1={
        <Box mt="10">
          <Heading size="2xl">Built to engage virtually</Heading>
          <Text my="10" fontSize="2xl">
            The tools you need to come prepared and build trust with new
            customers right from your desk.
          </Text>
          <Link href="/signup">
            <Button size="lg">Start Free Trial</Button>
          </Link>
        </Box>
      }
      col2={
        <VideoPlayer
          title="HOVER - Remote Engagement for Contractors"
          src="https://fast.wistia.net/embed/iframe/fcpg9h6c6t?videoFoam=true&autoplay=true"
        />
      }
    />
    <InfoSection
      sectionTitle="Impress homeowners in virtual meetings"
      infoItems={INFO_ITEMS}
      numColumns={3}
    />
    <FeaturedPosts
      mainPost={FEATURED_POSTS.mainPost}
      secondaryPosts={FEATURED_POSTS.secondaryPosts}
    />
    <FAQSection />
    <TryHoverTodaySection />
  </Layout>
);

export default RemoteEngagementForContractors;
